import { type MutableRefObject, forwardRef } from 'react'

import { useTranslation } from 'react-i18next'

interface Props {
    isEditable: boolean
    text: string
    setText: (text: string) => void
    className: string
    [k: string]: any
    setIsDraggable: (value: boolean) => void
}

interface IRef {
    draggable: MutableRefObject<HTMLDivElement>
    input: MutableRefObject<HTMLInputElement>
}

const DraggableTextInput = forwardRef<IRef, Props>(
    ({ text, setText, setIsDraggable, className, ...props }, ref) => {
        const { t } = useTranslation()
        const placeholder = t('addYourTextHere')

        return (
            <div
                {...props}
                className={`text__draggable ${className}`}
                ref={(ref as any)?.draggable}
            >
            <span
                onFocus={() => {
                    setIsDraggable(false)
                }}
                onBlur={() => {
                    setIsDraggable(true)
                }}
                className='text__draggable__input'
                ref={(ref as any)?.input}
                data-placeholder={placeholder}
                contentEditable
                suppressContentEditableWarning={true}
                onInput={e => {
                    setText?.(e.currentTarget.innerText)
                }}
                // 👇 These two lines fix mobile input issues
                style={{
                    minHeight: '2rem', // ensures it's tappable
                    userSelect: 'text', // required for mobile
                    touchAction: 'manipulation', // allows focus
                }}
            >
                {text}
            </span>
            </div>
        )
    }
)
DraggableTextInput.displayName = 'DraggableInput'

export default DraggableTextInput
